/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BulkUploadErrorMessage
 */
export interface BulkUploadErrorMessage {
    /**
     * 
     * @type {string}
     * @memberof BulkUploadErrorMessage
     */
    field?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BulkUploadErrorMessage
     */
    message?: string | null;
}

export function BulkUploadErrorMessageFromJSON(json: any): BulkUploadErrorMessage {
    return BulkUploadErrorMessageFromJSONTyped(json, false);
}

export function BulkUploadErrorMessageFromJSONTyped(json: any, ignoreDiscriminator: boolean): BulkUploadErrorMessage {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'field': !exists(json, 'field') ? undefined : json['field'],
        'message': !exists(json, 'message') ? undefined : json['message'],
    };
}

export function BulkUploadErrorMessageToJSON(value?: BulkUploadErrorMessage | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'field': value.field,
        'message': value.message,
    };
}


